import { render, staticRenderFns } from "./matrixChoiceOtherItem.vue?vue&type=template&id=3613300a"
import script from "./matrixChoiceOtherItem.vue?vue&type=script&lang=js"
export * from "./matrixChoiceOtherItem.vue?vue&type=script&lang=js"
import style0 from "./matrixChoiceOtherItem.vue?vue&type=style&index=0&id=3613300a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports